import React from 'react';
import { Divider } from 'semantic-ui-react';
import { WorksheetPageIndex } from 'services/worksheet/types';
import PrintSprayWorksheetHeader from '../PrintSprayWorksheetHeader';
import PrintSprayWorksheetEquipmentSet from '../PrintSprayWorksheetEquipmentSet';
import PrintSprayWorksheetCalibrations from '../PrintSprayWorksheetCalibrations';
import PrintSprayWorksheetProducts from '../PrintSprayWorksheetProducts';
import PrintSprayWorksheetCompletionDetails from '../PrintSprayWorksheetCompletionDetails';
import PrintSprayWorksheetSignOff from '../PrintSprayWorksheetSignOff';

interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export class PrintSprayWorksheetPage extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex } = this.props;

        return (
            <div className="print-worksheet-page">
                <PrintSprayWorksheetHeader pageIndex={pageIndex} />
                <Divider />
                <PrintSprayWorksheetEquipmentSet pageIndex={pageIndex} />
                <PrintSprayWorksheetCalibrations pageIndex={pageIndex} />
                <PrintSprayWorksheetProducts pageIndex={pageIndex} />
                <PrintSprayWorksheetCompletionDetails pageIndex={pageIndex} />
                <PrintSprayWorksheetSignOff />
            </div>
        );
    }
}

export default PrintSprayWorksheetPage;
